import React, {Fragment, useState} from "react";
import HoverButton from "../../buttons/HoverButton";
import Coupon from "./coupon";

export default function FeedbackSent(props) {

    const [couponAreaOpened, setCouponAreaOpened] = useState(false);

    const fullAccessPaid = () => {
      return (
          <React.Fragment>
              <p className={'feedback__txt'}>Your comments are truly appreciated. Our team uses all feedback to further the testing experience.</p>
          </React.Fragment>
      )
    };

    const individualPaid = () => {
        return <Fragment>
            <p className={'feedback__txt'}>Ready to continue testing and get your matches?</p>
            <ul className={'tick-list'}>
                <li>Access all six tests, full test results and insights </li>
                <li>Reveal your final career matches based on all your results</li>
                <li>Receive a complete and personalized career report</li>
            </ul>
            <HoverButton   href={'/upgrade'} className={'button--green--large'}>Get Access<span className="small-icons next-arrow-white-l"></span></HoverButton>
        </Fragment>
    };

    if (props.rate === 'poor_rate') {
        return (
            <Fragment>
                <h3 className="feedback__msg feedback__msg--with-space">Thanks for your feedback!</h3>
                <p className={'feedback__txt'}>We take any negative comments on board to improve the CareerHunter testing experience on upcoming, future updates.</p>
                <p className={'feedback__contact'}>See our <a href="/faq">FAQs</a> or <a href="/contact">Contact</a> us if you have any questions or need help.</p>
                <Coupon coupon={props.coupon} />
            </Fragment>
        );
    }

    if (props.rate === 'average_rate') {
        return (
            <Fragment>
                <div className={"large-icon blue-clap-icon mar-auto"}/>
                <h3 className="feedback__msg feedback__msg--with-space">Feedback sent!</h3>
                {props.full_access ? fullAccessPaid() : individualPaid()}
                <Coupon coupon={props.coupon} />
            </Fragment>
        );
    }

    return <Fragment>`
        <div className={"large-icon blue-clap-icon mar-auto"}/>
        <h3 className="feedback__msg feedback__msg--with-space">Feedback sent!</h3>
        <p className={'feedback__txt'}>Want to share your experience to other career hunters?</p>
        <p className={'feedback__txt feedback__txt--small'}>Let others know about your experience:</p>
        {props.testimonial && <div className="testimonials__box testimonials__box--preview">
            <div className="testimonials__info">
                <div className={'testimonials__pic'}>
                    <div className={`avatar-icon ${props.testimonial.avatar_icon}`} />
                    <div className="small-icons green-quote"/>
                </div>
                <div>
                    <p className="testimonials__commenter">{props.testimonial.name}</p>
                    <p className="testimonials__date">{props.testimonial.date}</p>
                </div>
            </div>
            <p className="testimonials__comment">{props.testimonial.text}</p>
            <p className="testimonials__match">{props.testimonial.match}</p>
        </div>}
        <div className={'feedback__buttons-area'}>
            <HoverButton onClick={props.close} className={'button--green--large button--gray'}>No thanks</HoverButton>
            <HoverButton onClick={props.onTestimonialFormOpen} className={'button--green--large'}>Edit testimonial <span className="small-icons next-arrow-white-l"/></HoverButton>
        </div>

        {props.coupon && <div className={`feedback__coupon-slider${couponAreaOpened ? ' is-opened' : ''}`}>
            <a className={'feedback__coupon-title'} onClick={() => setCouponAreaOpened(!couponAreaOpened)}>REVEAL THANK YOU COUPON</a>
            <Coupon coupon={props.coupon} />
        </div>}
    </Fragment>

}